import getBlocksByNamespaces from './getBlocksByNamespaces';

export default (state, namespace) => {
  const blocks = getBlocksByNamespaces(state, [namespace]);
  return blocks.length ? blocks[0] : null;
};
